import { render, staticRenderFns } from "./AddClassroom.vue?vue&type=template&id=0f7b7328&scoped=true"
import script from "./AddClassroom.vue?vue&type=script&lang=js"
export * from "./AddClassroom.vue?vue&type=script&lang=js"
import style0 from "./AddClassroom.vue?vue&type=style&index=0&id=0f7b7328&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b7328",
  null
  
)

export default component.exports